(ns frontend.ui.component.label.view
  (:require
   [herb.core :refer [<class]]
   [frontend.ui.component.label.style :as style]))

(defn label
  "HTML label that encapsulates its children.

  See `checkbox/view` for an example usage."
  [child & children]
  (into [:label {:class (<class style/label)}] (cons child children)))
